import * as types from './actionTypes.predefinedScripts';

export default function PredefinedScriptsReducer(state = null, action) {
    switch (action.type) {

        case types.GET_PREDEFINED_SCRIPTS_OK:
            return [
                ...action.predefinedScripts,
            ];

        default:
            return state;
    }
}